module.exports = __webpack_public_path__ + "img/home-pic-11.50777128.jpg";